// @flow weak

import PropTypes from 'prop-types';
import PureRenderMixin from 'react-addons-pure-render-mixin';
import React from 'react';
import ReactDOM from 'react-dom';
// !!! IMPORTANT !!!
//
// This file is shared between the zapier/zapier and zapier/next-js repository.
// Any changes made here should be reflected in there as well.
// For more information, see: https://zapier.quip.com/xaKqAOpdhpY2#ZXFACA8Jnp9
import _ from 'lodash';
import createReactClass from 'create-react-class'; // eslint-disable-line no-restricted-syntax

import ChoiceListItem from 'app/common/components/ChoiceListItem';
import WindowKeydown from 'app/common/components/WindowKeydown';
import { getRef, setRef } from 'app/common/utils/ReactUtils';

import type { AnyComponent } from 'app/common/types';

const noop = () => {};

export type ChoiceListValueType = string | number;

export type ChoiceListTypes = {
  Item: AnyComponent,
  hasCustomChoiceHandlers: boolean,
  itemClassName?: string,
  items: Array<{}>,
  itemValueKey: string,
  onChoose: () => void,
  shouldWrapAround?: boolean,
  className?: string,
  value?: ChoiceListValueType,
};

export const ChoiceListValuePropType = PropTypes.oneOfType([
  PropTypes.string,
  PropTypes.number,
]);
const ChoiceList = createReactClass({
  displayName: 'ChoiceList',
  keyboardHandlers: (null: ?(Function[])),
  mixins: [PureRenderMixin],

  propTypes: {
    Item: PropTypes.func.isRequired,
    // See `ChoiceListItem` for details on this prop
    hasCustomChoiceHandlers: PropTypes.bool.isRequired,
    itemClassName: PropTypes.string,
    items: PropTypes.arrayOf(PropTypes.object).isRequired,
    itemValueKey: PropTypes.string.isRequired,
    onChoose: PropTypes.func.isRequired,
    shouldWrapAround: PropTypes.bool,
    className: PropTypes.string,
    value: ChoiceListValuePropType,
  },

  getDefaultProps() {
    return {
      hasCustomChoiceHandlers: false,
      itemValueKey: 'value',
    };
  },

  getInitialState() {
    return {
      isKeyboardControlled: false,
    };
  },

  takeKeyboardControl() {
    this.setState({ isKeyboardControlled: true });
  },

  relinquishKeyboardControl() {
    this.setState({ isKeyboardControlled: false });
  },

  getKeyboardHandlers() {
    const wrapWithControl = fn => () => {
      this.takeKeyboardControl();
      fn();
    };
    return {
      up: wrapWithControl(() => this.chooseSibling(-1)),
      down: wrapWithControl(() => this.chooseSibling(1)),
      enter: wrapWithControl(() =>
        this.chooseDirectly(this.getFirstValidValue())
      ),
    };
  },

  getItemValue(item = {}) {
    return item[this.props.itemValueKey];
  },

  getIndexOfCurrentValue() {
    const { value, items } = this.props;
    return items.map(this.getItemValue).indexOf(value);
  },

  // It's possible that the `value` prop could have been from
  // an `item` that was once in `items` but later that `item`
  // and therefore that `value` were filtered out of `items`,
  // in which case we want to default to the first available `item`.
  getFirstValidValue() {
    const { items, value } = this.props;
    const isValueInItems = items.some(
      item => this.getItemValue(item) === value
    );
    return isValueInItems ? value : this.getItemValue(items[0]);
  },

  clamp(idx) {
    const firstIdx = 0;
    const lastIdx = this.props.items.length - 1;
    return Math.min(lastIdx, Math.max(idx, firstIdx));
  },

  chooseSibling(offset) {
    const curIdx = this.getIndexOfCurrentValue();
    const newIdx = curIdx + offset;
    const nextIdx = this.clamp(newIdx);
    const isAtEndOfList = newIdx !== nextIdx;
    const nextValue = this.getItemValue(this.props.items[nextIdx]);
    const nextItem = this.props.items[nextIdx] || {};
    if (!nextItem.isDisabled) {
      this.chooseIndirectly(nextValue);
    } else if (!isAtEndOfList) {
      this.chooseSibling(offset > 0 ? offset + 1 : offset - 1);
    }
  },

  findItemByValue(value) {
    return _.find(this.props.items, item => this.getItemValue(item) === value);
  },

  choose(value, didConfirm) {
    const item = this.findItemByValue(value);
    if (!item.isDisabled) {
      this.props.onChoose(value, didConfirm, item);
    }
  },

  chooseDirectly(value) {
    this.choose(value, true);
  },

  chooseIndirectly(value) {
    this.choose(value, false);
  },

  UNSAFE_componentWillMount() {
    // Attach to component instance so we keep the same object
    // and function instances.
    this.keyboardHandlers = this.getKeyboardHandlers();
  },

  componentWillUnmount() {
    this.keyboardHandlers = null;
  },

  componentDidMount() {
    this.scrollSelectedItemIntoViewIfNeeded();
  },

  componentDidUpdate() {
    this.scrollSelectedItemIntoViewIfNeeded();
  },

  scrollSelectedItemIntoViewIfNeeded() {
    const list = getRef(this, 'list');
    const selectedItem = getRef(this, 'selectedItem');
    if (!selectedItem) {
      return;
    }
    const listNode = (ReactDOM.findDOMNode(list): any);
    const listRect = listNode.getBoundingClientRect();
    const itemNode = (ReactDOM.findDOMNode(selectedItem): any);
    const itemRect = itemNode.getBoundingClientRect();
    const diffTop = listRect.top - itemRect.top;
    const diffBtm = itemRect.bottom - listRect.bottom;
    // Align top of top item to top of list
    if (diffTop > 0) {
      listNode.scrollTop -= diffTop;
    } else if (diffBtm > 0) {
      // Align bottom of bottom item to bottom of list
      listNode.scrollTop += diffBtm;
    }
  },

  renderItem(item) {
    const { value, Item, itemClassName } = this.props;
    const { isKeyboardControlled } = this.state;
    const itemValue = this.getItemValue(item);
    const isSelected = itemValue === value;
    return (
      <ChoiceListItem
        className={itemClassName}
        hasCustomChoiceHandlers={this.props.hasCustomChoiceHandlers}
        isSelected={isSelected}
        Item={Item}
        key={item.key || itemValue}
        {...item}
        onChoose={this.chooseDirectly}
        onSoftChoose={isKeyboardControlled ? noop : this.chooseIndirectly}
        ref={isSelected ? setRef(this, 'selectedItem') : null}
        value={itemValue}
      />
    );
  },

  render() {
    return (
      <WindowKeydown handlers={this.keyboardHandlers}>
        <ul
          className={this.props.className}
          onMouseMove={this.relinquishKeyboardControl}
          ref={setRef(this, 'list')}
          role="menu"
        >
          {this.props.items.map(this.renderItem)}
        </ul>
      </WindowKeydown>
    );
  },
});

export default ChoiceList;
